import React from "react";

import InitialsAvatar from "../../../../shared/components/InitialsAvatar";

import styles from "./FotoAluno.module.scss";

const FotoAluno = ({ foto, nome, numero }) => {
    return (
        <div className={styles.fotoInfo}>
            <div className={styles.foto}>
                <span className={styles.aluno}>Aluno</span>
                {foto != null ? (
                    <div className={styles.fotoAluno}>
                        <img src={foto} alt="foto" />
                    </div>
                ) : (
                    <div className={styles.iniciaisAluno}>
                        <InitialsAvatar name={nome} />
                    </div>
                )}
                {nome !== null && (
                    <div className="container">
                        <div>
                            <span className={styles.nome}>{nome}</span>
                        </div>
                        <div className={styles.separador}></div>
                        <div>
                            <span className={styles.numero}>{numero}</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FotoAluno;
